import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: 'http://localhost:3453/',
  baseURL: 'https://api.community-hub.e-deeshatechnologies.com',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - FIXED: added missing arrow function syntax
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {  // ← Added the missing arrow function syntax here
    if (error.response?.status === 401) {
      if (!window.location.pathname.includes('/login')) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;